export default "__VITE_ASSET__D66Tqm7t__"